import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useWorkBlockShowModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.showWorkBlockModalState, ...args };
    updateGlobalState({ showWorkBlockModalState: newState });
  };

  return {
    block: state.showWorkBlockModalState.block,
    close: () => {
      setState({ block: null, isOpen: false });
    },
    isOpen: state.showWorkBlockModalState.isOpen,
    open: (block) => {
      setState({ block, isOpen: true });
    },
  };
}
